<template>
  <el-dialog
    append-to-body
    width="600px"
    title="查看描述"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="replenish_desc" label="">
        <el-input
          type="textarea"
          readonly
          :rows="3"
          placeholder="请输入"
          v-model="form.data.replenish_desc"
          clearable
        >
        </el-input>
      </el-form-item>
    </el-form>
    <!-- <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >保存</el-button
        >
      </el-row>
    </template> -->
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      info: {},
      form: {
        loading: false,
        data: {
          replenish_desc: "",
        },
        rules: {
          replenish_desc: [
            { required: true, message: "必填", trigger: "change" },
          ],
        },
      },
    };
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.info = row;
      this.form.data = { replenish_desc: row.replenish_desc || "" };
    },
    reset(done) {
      this.form.data = { replenish_desc: "" };
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let _param = {
            id: this.info.id,
            replenish_desc: this.form.data.replenish_desc,
          };
          let apiUrl = "/admin/flex_job/descReplenish";
          this.$http
            .post(apiUrl, _param)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("保存成功");
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
